import { render } from "./study-section.vue?vue&type=template&id=29d590a0"
import script from "./study-section.vue?vue&type=script&lang=js"
export * from "./study-section.vue?vue&type=script&lang=js"

import "./study-section.vue?vue&type=style&index=0&id=29d590a0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__